"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOffsetStyles = void 0;
var _useInternalSpacingStyles = require("./internal/useInternalSpacingStyles");
const useOffsetStyles = ({
  offset,
  offsetBottom,
  offsetEnd,
  offsetHorizontal,
  offsetStart,
  offsetTop,
  offsetVertical
}) => {
  return (0, _useInternalSpacingStyles.useInternalSpacingStyles)({
    all: offset,
    bottom: offsetBottom,
    end: offsetEnd,
    horizontal: offsetHorizontal,
    start: offsetStart,
    top: offsetTop,
    vertical: offsetVertical,
    isInverted: true
  });
};
exports.useOffsetStyles = useOffsetStyles;